// Core
import React from "react"
import styled from "styled-components"

// General Components
import BaseContainer from "../../../../components/BaseContainer"

// Components
import CopyContainer from "./components/CopyContainer"

// Assets
// import Img from "../../../../assets/miscellaneous/pr-sinval.png"
import Img from "../../../../assets/miscellaneous/pr_pra.png"

// Style
import size from "../../../../styles/size"

const Section = styled.section`
  background-color: black;
  padding-top: 10rem;
  padding-bottom: 10rem;

  @media (max-width: ${size.laptop}) {
    padding-top: 1rem;
  }
`

const ImgContainer = styled.div`
  width: 100%;
  height: 100%;
  text-align: right;

  img {
    margin-top: -10px;
    max-width: 450px;
  }

  @media (max-width: ${size.laptop}) {
    text-align: center;
    order: -1;

    img {
      width: 100%;
      margin-top: 5rem;
    }
  }
`

export default function Leadership() {
  return (
    <Section>
      <BaseContainer>
        <CopyContainer />
        <ImgContainer>
          <img src={Img} alt="Nossa Liderança" loading="lazy" />
        </ImgContainer>
      </BaseContainer>
    </Section>
  )
}
